export const SET_GOALS_LIST = 'SET_GOALS_LIST';
export const SET_GOALS_HEADER_COUNT = 'SET_GOALS_HEADER_COUNT';
export const SET_GOAL_DETAILS = 'SET_GOAL_DETAILS';
export const SET_COMPLETED_TASKS_BY_EMPLOYEE = 'SET_COMPLETED_TASKS_BY_EMPLOYEE';
export const SET_PERFORMANCE_TIMELINE = 'SET_PERFORMANCE_TIMELINE';
export const CLEAR_GOALS_STATE = 'CLEAR_GOALS_STATE';